import React from "react"
import { Popconfirm } from "antd"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom"
import './style.css'

const Back = (props) => {
    const { url, title } = props
    const navigate = useNavigate();
    const { t } = useTranslation(['common'])

    return (
        <Popconfirm
            cancelText={t('common:no')}
            okText={t('common:yes')}
            placement="left"
            title={title}
            onCancel={(e) => {
                e.stopPropagation()
                return null
            }}
            onConfirm={(e) => {
                e.stopPropagation()
                navigate(url, { replace: true });
                //window.location.href = url
            }}
        >
            <Link to="/">
                <div className="constructor_link_back">
                    <img alt="" src="/Arrow.svg" />
                    {t("common:back")}
                </div>
            </Link>
        </Popconfirm>
    )
}
export default Back